module.exports = __webpack_public_path__ + "media/images/clients/facebook_btn_share-d9d381a9bf851fe0cff329148098aaac.png";